import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INVALID_ID } from '../../../constants/ap_id_constants';
import { APCourseInfoModel } from '../models/course_info_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadMmCourseInfoCommand',
    function loadCourseInfoCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngAPCourseInfoModel: APCourseInfoModel,
      log: any
    ) {
      return defineCommandORM(
        'loadMmCourseInfoCommand',
        function loadMmCourseInfoCommand(deferred, courseNK: string, termId: number = INVALID_ID) {
          $http
            .get(`/reg/course/nk/${courseNK}/`)
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              ngAPCourseInfoModel.clear();
              ngAPCourseInfoModel.write({ termId, ...data });
              deferred.resolve(data);
            })
            .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
              log.issue('failed to retrieve info for course');
              deferred.reject(e.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/commands/load_mm_course_info_command.ts